export const Paths = {
  LOGIN: "/",
  PROFILE: "/profile",
  ORGANIZATION: "/organization",
};
